export default __webpack_public_path__ + "static/Icon-Estetica-fceed13a5555167a138e70864a46fe7c.svg";